module.exports = __webpack_public_path__ + "img/chess_bg.095d7ee4.png";